import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Row, Col, Form, Space, Input, Spin, Select, Tooltip } from "antd";
import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import PropTypes from "prop-types";
import { getRequest } from "../../axios";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";

const StepInquiryValueVendor = ({ state, setState, CompanyId, data, categoryTree }) => {
  const formRef = useRef();
  const materialTypeLoadedRef = useRef(false);
  const rowMaterialTypesLoadedRef = useRef({});
  const { t } = useTranslation();
  const [apiLoading, setApiLoading] = useState(false);
  const [materialType, setMaterialType] = useState([]);
  const [selectedMaterialTypes, setSelectedMaterialTypes] = useState({});
  const [cityDropdownOptionsAddVendor, setCityDropdownOptionsAddVendor] =
    useState([]);
  const [rowMaterialTypes, setRowMaterialTypes] = useState({});

  // useEffect(() => {
  //   getCitye();
  // }, [CompanyId]);

  const getCitye = async () => {
    await getRequest(
      `vendor-assign-city/city-by-site/?company_id=${CompanyId}`
    ).then((response) => {
      setCityDropdownOptionsAddVendor(response.data.data);
    });
  };

  const getMaterialTypeByCategory = async () => {
    try {
      const materialTypeResponse = await getRequest(
        `company-material-code/1/get-company-material/`
      );
      setMaterialType(materialTypeResponse.data.data);
    } catch (error) {
      console.error("Error fetching material types:", error);
    }
  };

  useEffect(() => {
    const initializeSelectedMaterials = () => {
      const selectedMaterials = {};
      state.vendor_inquiry_value.forEach((item, index) => {
        selectedMaterials[index] = item.company_material_type;
      });
      setSelectedMaterialTypes(selectedMaterials);
    };

    if (state.vendor_inquiry_value) {
      initializeSelectedMaterials();
    }
  }, [state.vendor_inquiry_value]);

  useEffect(() => {
    if (!materialTypeLoadedRef.current) {
      materialTypeLoadedRef.current = true;
    }
    getCitye();
  }, [CompanyId]);

  useEffect(() => {
    if (state.gst_no != null) {
      const modifiedInquiry = state?.vendor_inquiry_value?.map(
        (inquiryDetail) => {
          const { id, company, company_name, ...rest } = inquiryDetail;
          return rest;
        }
      );
    }
  }, [state.gst_no, state.vendor_inquiry_value]);

  const addInquiryCity = () => {
    let newPersonArr = [
      ...state.assign_city_to_vendor,
      {
        company: CompanyId,
        category_tree: null,
        material_type: [],
        city: [],
      },
    ];
    setState({ ...state, assign_city_to_vendor: newPersonArr });
    setWeightSizeInquiryFieldValueCity(newPersonArr);
  };

  const setWeightSizeInquiryFieldValueCity = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["category_tree" + objectKey] = objectValue.category_tree;
      fieldObject["material_type" + objectKey] = objectValue.material_type_name;
      fieldObject["city" + objectKey] = objectValue.city;
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const formatIndianNumber = (num) => {
    if (!num) return "";
    const x = num.toString().replace(/,/g, "");
    if (isNaN(x)) return "";
    const parts = x.split(".");
    let intPart = parts[0];
    let decimalPart = parts[1] ? "." + parts[1] : "";
  
    let lastThree = intPart.substring(intPart.length - 3);
    let otherNumbers = intPart.substring(0, intPart.length - 3);
  
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
  
    return (
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + decimalPart
    );
  };

  const handleCloneInquiryInputChange = (field, e, index) => {
    let rawInput = e.target.value.replace(/,/g, "").replace(/[^\d.]/g, "");
  
    const formattedInput = formatIndianNumber(rawInput);
  
    let newPersonArr = [...state.vendor_inquiry_value];
    newPersonArr[index][field] = formattedInput;
    setState({ ...state, vendor_inquiry_value: newPersonArr });
    formRef.current?.setFieldsValue({
      [`${field}${index}`]: formattedInput,
    });
  };
  

  const handleMaterialChangeForInquiry = (material, index, value) => {
    const updatedAssignMaterial = [...state.vendor_inquiry_value];
    updatedAssignMaterial[index].company_material_type = value;
    setState({ ...state, type_name: updatedAssignMaterial });
  };

  const handleCategoryChangeForInquiry = async (material, index, value) => {
    const updatedVendorInquiry = [...state.vendor_inquiry_value];
    updatedVendorInquiry[index].category_tree = value;
    updatedVendorInquiry[index].company_material_type = []; 
    setState({ ...state, vendor_inquiry_value: updatedVendorInquiry });

    formRef.current.setFieldsValue({
      [`company_material_type${index}`]: [],
    });
  };

  useEffect(() => {
    const fetchMaterials = async (index, categoryId) => {
      if (!categoryId) {
        setRowMaterialTypes((prev) => ({ ...prev, [index]: [] }));
        return;
      }
      
      if (rowMaterialTypesLoadedRef.current[categoryId]) {
        setRowMaterialTypes((prev) => ({
          ...prev,
          [index]: rowMaterialTypesLoadedRef.current[categoryId],
        }));
        return;
      }
      
      try {
        const res = await getRequest(
          `company/company-material-codes/?category_tree_id=${categoryId}`
        );
        const materials = res.data?.result?.data || [];
        
        rowMaterialTypesLoadedRef.current[categoryId] = materials;
        setRowMaterialTypes((prev) => ({
          ...prev,
          [index]: materials,
        }));
      } catch (e) {
        console.error("Error fetching materials", e);
        setRowMaterialTypes((prev) => ({ ...prev, [index]: [] }));
      }
    };

    state.vendor_inquiry_value.forEach((inquiry, index) => {
      if (inquiry.category_tree && !rowMaterialTypesLoadedRef.current[inquiry.category_tree]) {
        fetchMaterials(index, inquiry.category_tree);
      } else if (inquiry.category_tree) {
        setRowMaterialTypes((prev) => ({
          ...prev,
          [index]: rowMaterialTypesLoadedRef.current[inquiry.category_tree] || [],
        }));
      }
    });
  }, [state.vendor_inquiry_value]);


  const setWeightSizeInquiryFieldValue = (data) => {
    if (!formRef.current) return;
    
    let stateArr = [];
    let fieldObject = {};
  
    data.forEach((objectValue, objectKey) => {
      stateArr.push(objectValue);
      const categoryValue = objectValue.category_tree;
      if (categoryValue === null || categoryValue === undefined || categoryValue === "" || categoryValue === 0) {
        fieldObject["category_tree" + objectKey] = undefined;
      } else {
        fieldObject["category_tree" + objectKey] = categoryValue;
      }
      
      fieldObject["company_material_type" + objectKey] =
        objectValue.company_material_type || [];

        fieldObject["maximum_inquiry_value" + objectKey] =
        objectValue.maximum_inquiry_value != null
          ? formatIndianNumber(objectValue.maximum_inquiry_value)
          : "";
      
      fieldObject["minimum_inquiry_value" + objectKey] =
        objectValue.minimum_inquiry_value != null
          ? formatIndianNumber(objectValue.minimum_inquiry_value)
          : "";
      
      fieldObject["city" + objectKey] = objectValue.city || [];
    });
  
    formRef.current.setFieldsValue(fieldObject);
  };
  


  useEffect(() => {
    if (CompanyId) {
      const modifiedInquiry = state.vendor_inquiry_value.map(
        (inquiryDetail) => {
          const { id, company, company_name, ...rest } = inquiryDetail;
          return rest;
        }
      );
      setWeightSizeInquiryFieldValue(modifiedInquiry);
    }
  }, [state.vendor_inquiry_value, CompanyId, t]);
  const addInquiry = () => {
    const newIndex = state.vendor_inquiry_value.length;
    let newPersonArr = [
      ...state.vendor_inquiry_value,
      {
        company: CompanyId,
        category_tree: undefined,
        company_material_type: [],
        minimum_inquiry_value: null,
        maximum_inquiry_value: null,
        city: [],
      },
    ];
    setState({
      ...state,
      vendor_inquiry_value: newPersonArr,
    });
  };

  const removeInquiry = async (lastIndex) => {
    let newPersonArr = state.vendor_inquiry_value;
    newPersonArr.splice(lastIndex, 1);
    setState({ ...state, vendor_inquiry_value: newPersonArr });
    setWeightSizeInquiryFieldValue(newPersonArr);
  };

  const filteredMaterialTypes = materialType.filter((material) => {
    return !Object.values(selectedMaterialTypes).includes(material.type_name);
  });

  const handleCityChangeSite = (field, index, value) => {
    const updatedAssignCity = [...state.vendor_inquiry_value];
    updatedAssignCity[index].city = value;
    setState({ ...state, vendor_inquiry_value: updatedAssignCity });
  };
  return (
    <Spin spinning={apiLoading}>
      <Form autoComplete="off" ref={formRef}>
        <div className="vendorsubtitle">Inquiry Value</div>
        {state.vendor_inquiry_value &&
          state.vendor_inquiry_value.map((x, index) => {
            return (
              <Row key={index} className="customcol" gutter={[16]}>
              <Col xs={24} sm={24} md={12} xl={12} xxl={7}>
                  <Form.Item
                    name={`category_tree` + index}
                    label={t("Category")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("Select category")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      allowClear
                      placeholder={t("pl_select_category")}
                      onChange={(value) =>
                        handleCategoryChangeForInquiry("category_tree", index, value)
                      }
                      optionFilterProp="children"
                      maxTagCount="responsive"
                      style={{ width: '100%' }}
                    >
                      {categoryTree.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} xl={12} xxl={7}>
                  <Form.Item
                    name={`company_material_type` + index}
                    label={t("Material Type")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("Select material type")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      showArrow
                      showSearch
                      allowClear
                      placeholder={t("pl_material_type")}
                      onChange={(value) =>
                        handleMaterialChangeForInquiry("material", index, value)
                      }
                      optionFilterProp="children"
                      maxTagCount="responsive"
                      style={{ width: '100%' }}
                    >
                      {(rowMaterialTypes[index] || []).map((item) => {
                        return (
                        <Select.Option key={item.id} value={item.id}>
                          {item.material_type_name}
                        </Select.Option>
                      )})}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} xl={12} xxl={7}>
                  <Form.Item name={`city` + index} label={t("pl_city")} required>
                    <Select
                      mode="multiple"
                      showArrow
                      showSearch
                      maxTagCount="responsive"
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      placeholder={t("place_city")}
                      onChange={(value) =>
                        handleCityChangeSite("city", index, value)
                      }
                      prefix={<ZipCode />}
                      rules={[
                        {
                          required: true,
                          message: <Trans>{t("Select City")}</Trans>,
                        },
                      ]}
                    >
                      {cityDropdownOptionsAddVendor.map((item) => {
                        return (
                          <Select.Option
                            key={item.city_id}
                            value={item.city_id}
                          >
                            {item.city_name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={10} xl={10} xxl={4}>
                  <Form.Item
                    name={`minimum_inquiry_value` + index}
                    label={t("label_minimum_inquiry_value")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("min_inquiry_value")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      addonBefore="₹"
                      className="cust-input"
                      placeholder={t("pl_minimum_inquiry_value")}
                      onChange={(value) =>
                        handleCloneInquiryInputChange(
                          "minimum_inquiry_value",
                          value,
                          index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={10} xl={10} xxl={4}>
                  <Form.Item
                    name={`maximum_inquiry_value` + index}
                    label={t("label_maximum_inquiry_value")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("max_inquiry_value")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      addonBefore="₹"
                      className="cust-input"
                      placeholder={t("pl_maximum_inquiry_value")}
                      onChange={(value) =>
                        handleCloneInquiryInputChange(
                          "maximum_inquiry_value",
                          value,
                          index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={4} xl={4} xxl={2}>
                  <div className="addwrp">
                    <Space>
                      {index !== 0 && (
                        <MinusSquareFilled
                          className="add"
                          onClick={() => removeInquiry(index)}
                        />
                      )}
                      <PlusSquareFilled className="add" onClick={addInquiry} />
                    </Space>
                  </div>
                </Col>
              </Row>
            );
          })}
      </Form>
    </Spin>
  );
};

StepInquiryValueVendor.propTypes = {
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  CompanyId: PropTypes.number,
  data: PropTypes.array,
  categoryTree: PropTypes.object.isRequired,
};

export default StepInquiryValueVendor;
